module.exports = __webpack_public_path__ + "img/3PVRActivation.2333aae4.png";